import Vue from 'vue'
import User from '@/api/actions/user';
import Run from '@/api/actions/run';
import Documents from '@/api/actions/documents';

Vue.mixin({
  beforeCreate() {
    const options = this.$options;
    if (options.api) this.$api = options.api;
    else if (options.parent && options.parent.$api) this.$api = options.parent.$api
  }
})

class Api {
  constructor(store, hub, i18n) {
    this.store = store;
    this.i18n = i18n;
    // add RestModels here for all Requests
    this.user = new User(store, hub);
    this.run = new Run(store);
    this.documents = new Documents(store)
  }
}

export default Api
